import React, { memo, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createUseStyles, Modal, Advice, Text, Input } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'DeleteViewModal');
const DeleteViewModal = /*#__PURE__*/memo(_ref => {
  let {
    className,
    labels,
    isOpen,
    onDelete,
    onClose,
    selectedView,
    inputAutoFocus = true
  } = _ref;
  const classes = useStyles();
  const classNames = classnames(classes.root, className);
  const [value, setValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    t
  } = useWeb5Context();
  const onChange = useCallback(newValue => {
    setValue(newValue);
  }, []);
  const handleOnDelete = useCallback(() => {
    setIsLoading(true);
    onDelete && onDelete(selectedView).finally(() => {
      setIsLoading(false);
      onClose && onClose();
    });
  }, [onDelete, selectedView, onClose]);
  const handleOnClose = useCallback(() => {
    if (isLoading) return;
    onClose && onClose();
  }, [onClose, isLoading]);
  const canDelete = useMemo(() => {
    if (value === (labels === null || labels === void 0 ? void 0 : labels.confirmWord) || value === t('action_delete').toUpperCase()) {
      return true;
    }
    return false;
  }, [value, labels, t]);
  return /*#__PURE__*/React.createElement(Modal, {
    className: classNames,
    overlayClassName: classes.overlay,
    isOpen: isOpen,
    title: (labels === null || labels === void 0 ? void 0 : labels.title) || t('action_delete_views'),
    confirmText: (labels === null || labels === void 0 ? void 0 : labels.confirmText) || t('action_delete'),
    cancelText: (labels === null || labels === void 0 ? void 0 : labels.cancelText) || t('action_cancel'),
    onConfirm: handleOnDelete,
    onCancel: handleOnClose,
    onRequestClose: handleOnClose,
    useCornerClose: false,
    isConfirmDisabled: isLoading || !canDelete,
    isConfirmLoading: isLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContainer
  }, /*#__PURE__*/React.createElement(Advice, {
    className: classes.advice,
    type: "error",
    showIcon: true
  }, (labels === null || labels === void 0 ? void 0 : labels.adviceText) || t('label_delete_view_explanation')), /*#__PURE__*/React.createElement(Text, {
    className: classes.confirmText,
    type: "body"
  }, (labels === null || labels === void 0 ? void 0 : labels.confirmWriteText) || t('label_type_confirmation', [(labels === null || labels === void 0 ? void 0 : labels.confirmWord) || t('action_delete').toUpperCase()])), /*#__PURE__*/React.createElement(Input, {
    className: classes.input,
    placeholder: (labels === null || labels === void 0 ? void 0 : labels.confirmWritePlaceholder) || t('placeholder_text_field'),
    onChange: onChange,
    value: value,
    isFullWidth: true,
    isReadOnly: isLoading,
    autoFocus: inputAutoFocus
  }))));
});
process.env.NODE_ENV !== "production" ? DeleteViewModal.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  labels: PropTypes.shape({
    title: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    questionText: PropTypes.string,
    adviceText: PropTypes.string,
    confirmWriteText: PropTypes.string,
    confirmWord: PropTypes.string,
    confirmWritePlaceholder: PropTypes.string
  })
} : void 0;
export default DeleteViewModal;